import { useState, useEffect } from "react";
import API from "../providers/api";
import useLogin from "../providers/use_login";

export default (id) => {
  const { token, user } = useLogin();
  const [isBusy, setIsBusy] = useState(true);
  const [propuesta, setPropuesta] = useState([]);

  useEffect(() => {
    const fetchPropuesta = async () => {
      setIsBusy(true)
      const config = {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      };
      const res = await API.get("admin/propuesta/" + id, config);

      setIsBusy(false);
      console.log(res.data)
      setPropuesta(res.data || [])
    };

    if (!user || !id || !token) {
      setIsBusy(false)
      setPropuesta([])
      return
    }
    fetchPropuesta();
  }, [token, user, id]);

  return { propuesta, isBusy };
};
